<template>
  <div id="concretMixContract" v-loading="loading">
    <div class="buttons" v-loading="loading">
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="PrintContractD"
        style="margin: 10px 0"
        >打印 </el-button
      ><el-button
        type="primary"
        icon="el-icon-plus"
        @click="saveContractA"
        style="margin: 10px 10px"
        v-if="dialogForm.approveStatus != 3 && dialogForm.approveStatus != 2"
        >保存
      </el-button>
      <el-button type="primary" @click="setWatermark" style="margin: 10px 0"
        >设置水印
      </el-button>
      <div style="display: inline-flex; width: 300px;margin-left:150px;">
        <el-input v-model="inputPages" placeholder="总页数" style="margin-left: 10px;"></el-input>
        <el-input v-model="inputHeight" placeholder="单页高" style="margin-left: 10px;"></el-input>
        <el-input v-model="inputPosx" placeholder="偏移量" style="margin-left: 10px;"></el-input>
      </div>
    </div>
    <div
      ref="HTMLconcretMixContent"
      id="HTMLconcretMixContent"
      :class="printClass"
      :key="printClass"
    >
      <div class="HTMLconcretMixContract1">
        <div style="position: relative">
          <p
            class="contract_word_p"
            style="margin-bottom: 0;font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: center;"
          >
            <span style="font-size: 40px; font-family: 宋体; color: red"
              >青岛路桥建设集团有限公司</span
            >
          </p>
          <p
            class="contract_word_p"
            style=";font-size: 14px;font-family: &#39;Times New Roman&#39;, serif;text-align: right"
          >
            <span
              style="
                position: absolute;
                z-index: 8;
                left: 10px;
                top: 2px;
                width: 44px;
                height: 57px;
              "
              ><img
                width="44"
                height="57"
                src="@/assets/images/subContract/LaborContract/logo.png"
                alt="路桥logo"
            /></span>
          </p>
        </div>
        <hr style="margin-top: 0" />
        <p style="text-align: center; line-height: 150%">
          <strong
            ><span style="font-family: 黑体; line-height: 150%; font-size: 24px"
              >混凝土拌合加工运输合同</span
            ></strong
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >合同编号：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="serialNumber"
              >{{ detailForm.serialNumber || "QDLQ-" }}</span
            >
          </span>
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >签订时间：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="signDate"
              >{{ detailForm.signDate ? detailForm.signDate : "" }}</span
            ></span
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >签约地点：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="signPlace"
              >{{ detailForm.signPlace || "青岛市" }}</span
            ></span
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >甲方：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="partyA"
              >{{ detailForm.partyA || "青岛路桥建设集团有限公司" }}</span
            ></span
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >乙方：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="partyB"
              >{{ detailForm.partyB ? detailForm.partyB : "" }}</span
            ></span
          >
        </p>
        <p
          style="
            text-indent: 37px;
            line-height: 31px;
            font-family: 楷体_GB2312;
            font-size: 19px;
          "
        >
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              >根据《中华人民共和国民法典》及有关法律法规的规定，遵循平等、自愿和诚实信用的原则，双方就甲方
              <span
                style="
                  border-bottom: 1px solid rgb(44, 62, 80);
                  outline: 0;
                  min-width: 4cm;
                  display: inline-block;
                  text-indent: 5px;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                class="project"
                >{{ detailForm.project || "" }}</span
              >工程<span
                style="
                  border-bottom: 1px solid rgb(44, 62, 80);
                  outline: 0;
                  min-width: 6cm;
                  display: inline-block;
                  text-indent: 5px;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                class="projectName"
                >{{ detailForm.projectName || "" }}</span
              >混凝土拌合加工、运输 &nbsp;&nbsp;</span
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              >的事项协商一致，根据本工程的具体情况，订立以下合同条款：</span
            ></strong
          >
        </p>
        <p style="margin-left: 57px; line-height: 31px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              ><span style="font-family: 楷体_GB2312">第一条</span>
              <span style="font-family: 楷体_GB2312"
                >名称、型号及配套设备</span
              ></span
            ></strong
          >
        </p>
        <table
          ref="onlyPriceTable"
          width="100%"
          :key="tableKey"
          style="
            border-collapse: collapse;
            border-width: 1px;
            font-family: 楷体_GB2312;
            font-size: 16px;
          "
        >
          <thead style="display: table-header-group">
            <tr style="height: 35px" class="firstRow">
              <td
                width="47"
                valign="top"
                style="
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 16px"
                    >序号</span
                  >
                </p>
              </td>
              <td
                width="128"
                valign="top"
                style="
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 16px"
                    >&nbsp;<span style="font-family: 楷体_GB2312"
                      >名称</span
                    ></span
                  >
                </p>
              </td>
              <td
                width="79"
                valign="top"
                style="
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 16px"
                    >型号</span
                  >
                </p>
              </td>
              <td
                width="56"
                valign="top"
                style="
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 16px"
                    >单位</span
                  >
                </p>
              </td>
              <td
                width="56"
                valign="top"
                style="
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 16px"
                    >数量</span
                  >
                </p>
              </td>
              <td
                width="169"
                valign="top"
                style="
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 16px"
                    >配套</span
                  >
                </p>
              </td>
              <td
                width="57"
                valign="top"
                style="
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 16px"
                    >备注</span
                  >
                </p>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr
              style="height: 28px; page-break-inside: avoid"
              v-for="item in concretMixtableList"
              :key="item.id"
            >
              <td
                width="47"
                valign="center"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
              >
                {{ item.column0 }}
              </td>
              <td
                width="128"
                valign="center"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
              >
                {{ item.column1 }}
              </td>
              <td
                width="79"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
              >
                {{ item.column2 }}
              </td>
              <td
                width="56"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
              >
                {{ item.column3 }}
              </td>
              <td
                width="56"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
              >
                {{ item.column4 }}
              </td>
              <td
                width="169"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
              >
                {{ item.column5 }}
              </td>
              <td
                width="57"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
              >
                {{ item.column6 }}
              </td>
            </tr>
          </tbody>
        </table>
        <div
          style="display: flex"
          v-if="dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3"
        >
          <el-tooltip
            class="item"
            effect="dark"
            content="添加行"
            placement="top-start"
          >
            <i class="el-icon-plus" @click="addItem"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="删除行"
            placement="top-start"
          >
            <i class="el-icon-minus" @click="delItem"></i>
          </el-tooltip>
        </div>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >注：拌合机设置地点为<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 6cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="bhjSignPlace"
              >{{ detailForm.bhjSignPlace || "" }}</span
            ></span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >，混凝土运输车辆的实际配备数量以甲方施工现场的实际要求为准，乙方必须保证满足甲方施工使用。</span
          >
        </p>
        <p style="margin-left: 53px; line-height: 31px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              ><span style="font-family: 楷体_GB2312">第二条</span>
              <span style="font-family: 楷体_GB2312">合同期限：</span></span
            ></strong
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >本工程自<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 4cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="startDate"
              >{{ detailForm.startDate || "" }}</span
            >至<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 4cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="endDate"
              >{{ detailForm.endDate || "" }}</span
            >结束。</span
          >
        </p>
        <p style="margin-left: 53px; line-height: 31px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              ><span style="font-family: 楷体_GB2312">第三条</span>
              <span style="font-family: 楷体_GB2312"
                >混凝土拌合加工单价、总价；运输单价、总价；地点、及数量</span
              ></span
            ></strong
          >
        </p>
        <table
          ref="pricetableListref"
          width="100%"
          :key="tableKey1"
          style="
            border-collapse: collapse;
            border-width: 1px;
            font-family: 楷体_GB2312;
            font-size: 16px;
            page-break-before: always;
          "
        >
          <thead style="display: table-header-group">
            <tr style="height: 35px" class="firstRow">
              <td
                width="47"
                valign="top"
                style="
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 16px"
                    >序号</span
                  >
                </p>
              </td>
              <td
                width="128"
                valign="top"
                style="
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 16px"
                    >&nbsp;<span style="font-family: 楷体_GB2312"
                      >服务名称</span
                    ></span
                  >
                </p>
              </td>
              <td
                width="56"
                valign="top"
                style="
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 16px"
                    >单位</span
                  >
                </p>
              </td>
              <td
                width="56"
                valign="top"
                style="
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 16px"
                    >暂定砼数量</span
                  >
                </p>
              </td>
              <td
                width="70"
                valign="top"
                style="
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 16px"
                    >不含税单价</span
                  >
                </p>
              </td>
              <td
                width="70"
                valign="top"
                style="
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 16px"
                    >税率%</span
                  >
                </p>
              </td>
              <td
                width="70"
                valign="top"
                style="
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 16px"
                    >含税单价</span
                  >
                </p>
              </td>
              <td
                width="70"
                valign="top"
                style="
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 16px"
                    >含税总价（元）</span
                  >
                </p>
              </td>
              <td
                width="57"
                valign="top"
                style="
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 16px"
                    >备注</span
                  >
                </p>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr
              style="height: 28px; page-break-inside: avoid"
              v-for="item in pricetableList.slice(0, pricetableList.length - 3)"
              :key="item.id"
            >
              <td
                width="47"
                valign="center"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
              >
                {{ item.column0 }}
              </td>
              <td
                width="128"
                valign="center"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
              >
                {{ item.column1 }}
              </td>
              <td
                width="79"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
              >
                {{ item.column2 }}
              </td>
              <td
                width="56"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
              >
                {{ item.column3 }}
              </td>
              <td
                width="70"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
              >
                {{ item.column4 }}
              </td>
              <td
                width="70"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
              >
                {{ item.column5 }}
              </td>
              <td
                width="70"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
              >
                {{ item.column6 }}
              </td>
              <td
                width="70"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
              >
                {{ item.column7 }}
              </td>
              <td
                width="57"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
              >
                {{ item.column8 }}
              </td>
            </tr>
            <tr
              style="height: 28px; page-break-inside: avoid"
              v-for="(item, index) in pricetableList.slice(
                pricetableList.length - 3
              )"
              :key="item.id"
            >
              <td
                width="47"
                valign="center"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
              >
                {{ item.column0 }}
              </td>
              <td
                v-if="index == 0"
                width="128"
                valign="center"
                rowspan="3"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
              >
                {{ item.column1 }}
              </td>
              <td
                width="79"
                colspan="6"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
              >
                {{ index == 0 ? item.column2 : item.column1 }}
              </td>
              <td
                width="57"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
              >
                {{ index == 0 ? item.column3 : item.column2 }}
              </td>
            </tr>
          </tbody>
        </table>
        <div
          style="display: flex"
          v-if="dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3"
        >
          <el-tooltip
            class="item"
            effect="dark"
            content="添加行"
            placement="top-start"
          >
            <i class="el-icon-plus" @click="addItem1"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="删除行"
            placement="top-start"
          >
            <i class="el-icon-minus" @click="delItem1"></i>
          </el-tooltip>
        </div>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >3.2混凝土拌合加工单价为
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 2.5cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="bhjgdj"
              >{{ detailForm.bhjgdj || "综合单价" }}</span
            >
            （税率<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 1cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="bhjgretio"
              >{{ detailForm.bhjgretio || "" }}</span
            >

            %)，此单价包含乙方混凝土拌合机基础临建费用（含人、材、机等所有费用）、混凝土拌合机设备使用及折旧费（含设备进出场及安装拆除费）、装载机上料费和洒水车降尘费及后勤保障车费（含驾驶员工资、燃油等）、人工费（含食宿）、水电费（包括混凝土加工及生活用）等与拌合生产混凝土相关的配套辅助设备、设施、管理、协调、安全生产、利润、税金等所有费用以及为拌合生产混凝土所进行的设备维修、试验调试材料等辅助工作费用，并且此单价为固定单价，在合同履行期间不做任何调整，如乙方单方面变更价格，属乙方违约，甲方有权终止合同，并拒付所欠乙方混凝土拌合加工款，同时乙方承担给甲方造成全部的损失。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >3.3混凝土运输单价为&nbsp;&nbsp;<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                word-break: break-all;
                padding-bottom: 2px;
                line-height: 32px;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="hntysdj"
              >{{ detailForm.hntysdj || "综合单价" }}</span
            >
            （税率<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 1cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="hntysretio"
              >{{ detailForm.hntysretio || "" }}</span
            >

            %)，此单价是对乙方运输车辆折旧、维修、保养、燃油、附属油、司机工资、管理费、运输道路维修费（桩基混凝土灌注现场道路除外）及一切税费等在运输过程中所有费用和乙方利润等的全部偿付。</span
          >
          <!-- <span
                style="
                  border-bottom: 1px solid rgb(44, 62, 80);
                  outline: 0;
                  min-width: 5cm;
                  display: inline-block;
                  text-indent: 5px;
                "
                :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3"
                class="addPrice"
                >{{ detailForm.addPrice || "" }}</span
              > -->
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >3.4不含税单价固定不变，税金随着国家规定税率的调整而调整，最终税金金额以开具发票时的国家税率计算为准。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >3.5混凝土拌合加工数量由甲方根据工程实际需用数量安排确定，结算数量以乙方拌合机拌和出厂数量（甲方认可的电子自动计量打印设备打印的出厂数量凭证）及甲方施工现场实际签收的数量为准。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >3.6混凝土运输地点：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                word-break: break-all;
                padding-bottom: 2px;
                line-height: 32px;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="addPrice"
              >{{ detailForm.addPrice || "无" }}</span
            >。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 24px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >3.7混凝土运输的数量范围：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                word-break: break-all;
                padding-bottom: 2px;
                line-height: 32px;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="slfw"
              >{{ detailForm.slfw || "无" }}</span
            >。</span
          >
        </p>
        <p style="text-indent: 47px; line-height: 24px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              ><span style="font-family: 楷体_GB2312">第四条</span>
              <span style="font-family: 楷体_GB2312">结算方式与付款</span></span
            ></strong
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >4.1混凝土数量结算以方为单位，最终结算数量以双方签字（签收人：姓名：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 2cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="name"
              >{{ detailForm.name || "" }}</span
            >电话:<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 3cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="phone"
              >{{ detailForm.phone || "" }}</span
            >身份证号：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 4cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="idCard"
              >{{ detailForm.idCard || "" }}</span
            >）认可的混凝土出厂数量和实际签收数量为准。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >4.2每个月1日为双方对账确认日期，确认上一月份乙方所拌合加工混凝土数量、金额双方须在对账确认单上签字认可并加盖单位印章。</span
          >
        </p>
        <p
          style="
            text-indent: 37px;
            line-height: 31px;
            font-family: 楷体_GB2312;
            font-size: 19px;
          "
        >
          <span
            style="
              outline: 0;
              display: block;
              max-width: 776px;
              text-decoration: underline;
              white-space: pre-line;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="shuoming"
            >{{
              detailForm.shuoming ||
              "4.3若乙方砼拌和机用甲方的电费，则需从乙方混凝土加工款中扣除。"
            }}</span
          >
        </p>
        <p
          style="
            text-indent: 37px;
            line-height: 31px;
            font-family: 楷体_GB2312;
            font-size: 19px;
          "
        >
          <span>4.4付款：</span>
          <span
            style="
              border-bottom: 1px solid rgb(44, 62, 80);
              outline: 0;
              text-indent: 5px;
              word-break: break-all;
              padding-bottom: 2px;
              line-height: 32px;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="fksm1"
            >{{ detailForm.fksm1 || "无" }}</span
          >。
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >乙方必须指派专人到甲方收款,收款前必须向甲方出具符合国家税务规定的等额税率为<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 2cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="deretio"
              >{{ detailForm.deretio }}</span
            >的增值税专用发票，若未开具发票则甲方不予付款或付扣除税金后的金额；已开具发票的，出具符合财务规定的收据，并在第一次收取款项时，必须持与本合同乙方单位名称一致的授权收款委托书交甲方财务备案；如被授权收款人有变动，则由乙方单位重新开具授权收款委托书交甲方财务备案，否则，甲方不予付款。</span
          >
        </p>
        <p style="text-indent: 47px; line-height: 31px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              ><span style="font-family: 楷体_GB2312">第五条</span>
              <span style="font-family: 楷体_GB2312"
                >混凝土拌合加工运输要求</span
              ></span
            ></strong
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >5.1在甲方制定的施工生产计划时段内，乙方按照甲方提供的试验配比、技术要求、生产计划，为甲方拌和生产合格的混凝土拌合料。
            总体计划在<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 2cm;
                text-align: center;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="kgrqYear"
              >{{ detailForm.kgrqYear }}</span
            >年<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 1cm;
                text-align: center;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="kgrqMonth"
              >{{ detailForm.kgrqMonth }} </span
            >月<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                text-align: center;
                min-width: 1cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="kgrqDay"
              >{{ detailForm.kgrqDay }}</span
            >日以前完成设备调试、试验配比、试拌等准备工作，达到正常拌和生产要求。合同履行期间，为保证甲方工程质量和工期，乙方不得利用本合同约定地点的拌合机承揽其它拌合加工任务，否则乙方自行承担由此给甲方造成的一切经济损失。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >5.2在甲方制定的施工生产计划时段内，乙方按照甲方的生产计划及要求，高效合理组织车辆为甲方运输混凝土拌合料。乙方应保证不少于【<span
              style="
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                text-align: center;
                min-width: 0.5cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="carNum"
              >{{ detailForm.carNum }}</span
            >】辆车辆提供运输服务。</span
          >
        </p>
        <p style="text-indent: 47px; line-height: 31px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              ><span style="font-family: 楷体_GB2312">第六条</span>
              <span style="font-family: 楷体_GB2312">双方责任</span></span
            ></strong
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.1 甲方责任</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.1.1甲方负责及时提供水泥、矿渣粉、粉煤灰、砂石料、外加剂，</span
          ><strong
            ><span style="font-family: 仿宋; font-size: 21px"
              >&nbsp;</span
            ></strong
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            ><span style="font-family: 楷体_GB2312"
              >原材料的主体和品种、质量由甲方负责，</span
            >
            <span style="font-family: 楷体_GB2312"
              >乙方不得以任何理由擅自更换原材料。</span
            ></span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.1.2甲方负责生产技术指导，指导乙方调试生产配比、试拌、拌和生产。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.1.3甲方须制定总体拌和生产计划，计划调整时须提前1日时通知乙方，同时每次拌和生产时须提前2日通知乙方。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.1.4甲方负责按照合同条款及时为乙方支付拌合加工运输费用。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.2 乙方责任</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.2.1乙方必须保证混凝土拌和机、装载机及洒水车等相关辅助设备设施状况良好，数量合理，以及按照甲方要求，满足甲方工程施工使用。为保证混凝土拌和机正常生产所需的相关配套配件、材料等均由乙方自己负责并承担费用。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.2.2乙方须设混凝土拌合站现场管理经理（姓名：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 2cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="gljlAname"
              >{{ detailForm.gljlAname || "" }}</span
            >电话:<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 3cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="gljlAphone"
              >{{ detailForm.gljlAphone || "" }}</span
            >）在生产过程中必须服从甲方的管理指导，按照甲方提供的配合比和要求的质量、数量、时间进行生产。乙方操作人员应严格按照技术要求认真操作，保证混凝土拌合料的质量，生产过程中必须服从甲方的计划要求，根据工程需要安排昼夜生产。若因乙方原因影响甲方施工计划造成的经济损失由乙方承担。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.2.3乙方对所拌合加工的混凝土质量、规格、要求和标准均是乙方应该做到的和应尽的义务，同样也是乙方向甲方的承诺，无条件的遵守。无条件的服从和执行甲方、业主、监理公司所提出的混凝土质量、规格等缺陷，并做到对方满意。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.2.4乙方负责当地政府及民众的关系协调，例如土地性质问题、综合执法部门的要求及环保措施影响正常生产范围内的事项等，费用由乙方承担。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.2.5乙方负责混凝土拌和机水泥、粉煤灰、矿粉、外加剂、骨料及水的电子秤设备的标定校验并承担全部费用，同时乙方须及时提供甲方、业主及监理所要求的真实有效的设备标定证书。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.2.6
            乙方负责混凝土拌和机及相关配套设备的操作、维修、保养，配备的操作、维修人员及生产工人必须保证甲方连续生产的要求，同时正常生产过程中乙方设备出现故障后维修时间不得超过24小时。
          </span>
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.2.7乙方承担混凝土拌和生产过程中所产生的粉尘及其它污染所发生的费用。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.2.8乙方运输车辆进入混凝土拌合站及施工现场后，必须服从甲方施工管理人员调度与指挥，乙方应遵守甲方施工现场的规章制度。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.2.9
            乙方如发生行车事故（装卸料及运输途中）或其它安全责任事故，其责任和一切经济损失均由乙方承担。如给甲方造成经济损失的，应当承担赔偿责任。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.2.10
            乙方车辆必须按指定路线把混凝土运到指定地点，中途不准变卖、倾倒，一经发现，甲方本工程的混凝土损耗全部由乙方承担并扣除乙方混凝土运费。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.2.11
            乙方根据甲方施工用量及混凝土拌合站生产产量及时调度车辆，并保证在限定时间内到达工地。所有车辆及驾驶员必须证照、保险齐全，车况良好，乙方车辆在运输过程中与地方关系的协调（当地居民、交警、城管等）以及所发生的任何费用均由乙方自己负责协调和承担。因车辆原因造成甲方不能准时出料施工，影响甲方生产施工，造成的相应经济损失由乙方承担。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.2.12
            乙方车辆及驾驶员必须常驻混凝土拌合站现场且进场、退场、食宿、各种临时设施及水电等事项由乙方自行解决。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.2.13
            乙方车辆司机必须服从管理，听从指挥，运输中不能挑肥拣瘦，装卸混凝土要依次排队，并按要求签字，行车中遵守交通规则，严禁酒后开车、超速行驶，做到文明礼貌，优质服务。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.2.14
            在合同履行期间，砼运距一般以不超过20km内为标准，如若超公里数甲方会酌情考虑单独增加运输费用，若乙方消极怠工无理取闹的，按违约处理，并扣除当日混凝土运输费用作为罚金。
          </span>
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6.2.15
            乙方必须安排专门人员或施工队伍对混凝土运输过程中所产生的路面污染、撒漏进行清理及清扫并承担相关费用，若第三方进行清理、清扫，所发生的费用由甲方从乙方运输款中扣除。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              ><span style="font-family: 楷体_GB2312">第七条</span>
            </span></strong
          ><strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              >劳务用工及工资支付管理</span
            ></strong
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">7</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >.1
            乙方必须遵守国家法律、行政法规和政策的规定，及时办理和完善劳动用工、社会保险等手续，合法使用员工，保护员工合法权益，不得拖欠或克扣员工、（农）民工工资。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">7</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >.2
            乙方未能及时支付其员工或（农）民工工资时，乙方同意：若乙方就所劳务工程拖欠农民工工资，</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >出现上访现象，</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >甲方有权从</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >乙方混凝土加工款中扣除相应金额</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >发放乙方所欠农民工工资，</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">并且</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >乙方应向甲方支付等额违约金。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">7</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >.3
            甲方有权对乙方的员工工资支付等情况进行监督、检查，乙方不得以任何理由拒绝，并应为甲方的监督、检查提供便利。若乙方违反国家法律、行政法规及有关国家政策，拖欠或克扣员工工资，经甲方催告后在合理时间仍不纠正的，甲方将有权暂停支付</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">混凝土</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >加工款或单方面解除合同，由此造成的一切损失和责任由乙方承担。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 37px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              >第八条</span
            ></strong
          ><strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              >&nbsp;<span style="font-family: 楷体_GB2312"
                >安全环保施工、检查、防护</span
              ></span
            ></strong
          >
        </p>
        <p style="text-indent: 37px; line-height: 37px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">8</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >.1 乙方混凝土拌合机</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">施工</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >须持有合法有效的《安全生产许可证》</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >及符合环保部门规定的环评手续</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >，并严格遵守《中华人民共和国安全生产法》、国务院《建设工程安全生产条例》</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >、《中华人民共和国环境保护法》等法律法规的规定</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">，</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >乙方混凝土拌合机及配套设备设施必须符合</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >国家和有关部门的安全</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">、</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >环保管理规定并按安全</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">、</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >环保等相关部门的要求对混凝土拌合机及配套设备加装相关安全</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">、</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >环保措施</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">，</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >保证甲方工程施工的顺利进行；加强</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >混凝土拌合机操作</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >人员与机械的施工安全管理，对施工现场的防台、防火、防爆、防汛和防盗等采取严格的安全环保的防护措施，严格遵照甲方现场的一切安全环保的管理规定，保证施工现场安全</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">、</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">环保</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">、</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >文明施工。</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >严格遵守国家相关临时用电规范的要求，</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >强制采用三相五线的用电要求，并承担由于管理不力或技术措施不到位造成的事故责任和由此发生的费用；严格按安全环保标准进行施工，随时接受行业安全环保检查人员依法实施的监督检查，采取必要的安全环保防护措施，消除事故及环境污染隐患。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">8</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">.2</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">&nbsp;</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >乙方在动力设备、输电线路、地下管道、密封防震车间、易燃易爆地段以及临街交通要道附近施工时，施工开始前应向甲方提出安全环保防护措施</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >或《安全环保施工专项方案》</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >，经甲方认可后实施，安全环保防护措施费用</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >已包含在乙方混凝土加工单价中，不再另计。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 31px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              ><span style="font-family: 楷体_GB2312">第九条</span>
              <span style="font-family: 楷体_GB2312">违约责任</span></span
            ></strong
          >
        </p>
        <p style="text-indent: 42px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >9.1合同履行期间，甲乙双方应按照合同规定条款履行各自职责。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >9.2乙方应高效合理组织生产，如因设备原因、操作失误造成的废料，由乙方承担责任并赔偿甲方的损失。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >9.3乙方要积极按时完成甲方的生产计划，如因设备或乙方人员的原因未完成甲方生产要求，导致工期拖延，乙方承担责任及给甲方造成的损失。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">9.4</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >合同双方均不得采用虚假记录、虚假计量或其他方法在混凝土加工数量上弄虚作假。否则，除虚假部分的加工数量不得做为加工费计算依据外，还须得按虚假部分加工数量的加工费的十倍计算违约方应予承担的违约金。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >9.5合同签订前，乙方向甲方提供一套完整的供方企业资质，若乙方企业不具备承担本合同所明确的生产、经营资质，或合同签订后发现该企业已被工程所在地政府建管部门取消和限制在当地生产、经营等违法、违规现象，乙方承担全部的行政和法律后果，若给甲方造成损失的，应承担相应的损害赔偿责任。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >9.6乙方单位若发生企业变更、注册地址以及通信地址变更，必须向甲方提供企业变更后的相关材料，否则，甲乙双方发生纠纷，由乙方承担全部法律责任。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >9.7其他因乙方原因给甲方造成的一切损失，均由乙方承担。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              ><span style="font-family: 楷体_GB2312">第十条</span>
              <span style="font-family: 楷体_GB2312"
                >合同争议的解决方式：</span
              ></span
            ></strong
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >本合同的解释和执行适用中华人民共和国法律。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            ><span style="font-family: 楷体_GB2312"
              >本合同在履行过程中发生的争议，由双方当事人坦诚友好协商解决；也可由甲方当地工商行政管理部门调解</span
            ><span style="font-family: 楷体_GB2312"
              >,
              如果协商或者调解不能解决，应向签约地点所在地法院提起诉讼。因解决争议所产生的律师费、鉴定费等其他费用由乙方承担。</span
            ></span
          >
        </p>
        <p style="margin-left: 32px; line-height: 31px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              ><span style="font-family: 楷体_GB2312">第十一条</span>
              <span style="font-family: 楷体_GB2312"
                >本合同解除的条件：</span
              ></span
            ></strong
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >按《中华人民共和国民法典》有关条款执行。</span
          >
        </p>
        <p style="text-indent: 32px; line-height: 31px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              >第十二条</span
            ></strong
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >&nbsp;<span style="font-family: 楷体_GB2312"
              >本合同经甲乙双方企业法定代表人或委托代理人签字并加盖合同专用章后，方能生效。</span
            >
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              ><span style="font-family: 楷体_GB2312">第十三条</span>
              <span style="font-family: 楷体_GB2312">合同份数：</span></span
            ></strong
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >本合同共<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 1cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="contractTotal"
              >{{ detailForm.contractTotal }}</span
            >份，甲方执<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 1cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="contractAnum"
              >{{ detailForm.contractAnum }}</span
            >份，乙方执<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 1cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="contractBnum"
              >{{ detailForm.contractBnum }}</span
            >份，具同等法律效力。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <strong
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              ><span style="font-family: 楷体_GB2312">第十四条</span>
              <span style="font-family: 楷体_GB2312">其它约定</span></span
            ></strong
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >14.1乙方不服从管理或在工作中严重有损甲方单位形象的或对甲方利益造成重大损害的，甲方可对其解除合同，同时赔偿甲方的全部损失。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >14.2在正常拌合生产前拌和机的生产配合比调试、混凝土拌合料试拌工作，由乙方操作，乙方人员在甲方指导下进行，因配合比调试，试验拌合而产生的相关费用（拌合费、电费、人工费等）由乙方承担。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >14.3乙方负责混凝土拌合生产过程中的安全生产管理工作，必须为其混凝土加工、运输驾驶员及相关人员办理相关人身意外伤害保险并承担费用。在合同履行过程中发生的一切安全事故所造成的经济损失和应承担的责任由乙方全部承担，甲方不承担连带责任。</span
          >
        </p>
        <p style="text-indent: 42px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">14.4</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >乙方工人和车辆驾驶员上岗前，乙方必须对工人进行安全教育或安全交底并让工人佩戴好安全防护用品（比如：安全帽、帆布手套等）后方可进入混凝土拌合机场地。进入混凝土拌合机场地后，如因乙方人员不听从现场管理人员的管理而出现安全事故，其责任由乙方全部承担，甲方不承担连带责任</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">。</span>
        </p>
        <p style="margin-bottom: 0; text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >14.5乙方须设混凝土运输车辆现场管理经理（姓名：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 2cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="gljlBname"
              >{{ detailForm.gljlBname || "" }}</span
            >电话:<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 3cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="gljlBphone"
              >{{ detailForm.gljlBphone || "" }}</span
            >），制定运输车辆管理责任制度，并组织实施，加强对驾驶员的管理。在装卸料及运输过程中必须服从甲方的管理，服从甲方的计划要求，根据工程需要安排车辆昼夜运输。建立运输车辆使用、维修、检查制度，加强对运输车辆的日常检查与维修，严禁使用不符合条件的车辆运输。因车辆原因造成混凝土凝固、报废的，将给予</span
          ><span style="text-decoration: underline"
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              >&nbsp;</span
            ></span
          ><span style="text-decoration: underline"
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              >5000</span
            ></span
          ><span style="text-decoration: underline"
            ><span style="font-family: 楷体_GB2312; font-size: 19px"
              >&nbsp;</span
            ></span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >元以上罚款，并按混凝土材料单价折算，在运费中扣除。如发现乙方管理人员或驾驶员和他人有不正当的交易而损害甲方利益，甲方将给予乙方以一罚十的经济处罚并拒付乙方混凝土运输款。</span
          >
        </p>
        <p style="margin-bottom: 0; text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >14.6乙方拌和机在完成甲方工程施工生产任务后，双方对乙方拌合机所剩甲方原材料（水泥、矿渣粉、粉煤灰及外加剂等）进行盘点确认，乙方必须如数归还甲方所剩所有原材料</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">。</span>
        </p>
        <p style="margin-bottom: 0; text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >14.7甲乙双方间的债权、债务，在未达成一致的前提下，均不得以任何方式转让给第三方。</span
          >
        </p>
        <p style="margin-bottom: 0; text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >14.8乙方拌和机及运输车辆必须保持外观清洁，卸完材料必须及时在专门场所把卸料口清洗干净，不得造成路面及甲方施工现场的污染；运输车辆驶出混凝土拌合站前，必须将车辆槽帮、车轮冲洗干净，不得带泥砂等行驶；乙方必须要定期对其人员及司机进行环境保护法律、法规知识教育培训，车辆运输不可装的过满，严禁泄露和遗撒。若因乙方运输车辆泄露遗撒，造成损失的，乙方承担全部责任及全部经济赔偿并处罚款</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">500</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            ><span style="font-family: 楷体_GB2312">元</span
            ><span style="font-family: 楷体_GB2312">/次，</span></span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >给甲方造成的经济损失和应向甲方缴纳的罚款，由甲方从乙方的混凝土运输款中扣除</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >。甲方根据业主要求对乙方拌和机加装信息化管理配套设施，乙方必须无条件给予配合，乙方混凝土拌和机应具备相关硬件要求。</span
          >
        </p>
        <!-- <p style="margin-bottom: 0; text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >14.9甲乙双方间的债权、债务，在未达成一致的前提下，均不得以任何方式转让给第三方。</span
          >
        </p> -->
        <p style="margin-bottom: 0; text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >14.9本合同未涉及的条款，双方可签订补充协议，但须经甲乙双方企业法定代表人或委托代理人签字并加盖合同专用章后，方能生效,</span
          ><span style="font-family: 宋体; font-size: 14px">&nbsp;</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            ><span style="font-family: 楷体_GB2312"
              >补充协议规定与本合同具有同等效力。</span
            >
            &nbsp;&nbsp;</span
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">&nbsp;</span>
        </p>
        <table width="100%" style="border-collapse: collapse">
          <tbody>
            <tr
              style="height: 100px; font-family: 楷体_GB2312; font-size: 19px"
              class="firstRow"
            >
              <td
                width="284"
                style="
                  border-width: 0;
                  border-color: windowtext;
                  padding: 2px 7px;
                  border-style: solid;
                "
              >
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >甲方单位（盖章）：</span
                  ><span
                    style="font-size: 19px"
                    class="partA_gongzhang"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_gongzhang }}</span
                  >
                </p>
                <p style="line-height: 150%">
                  <span
                    style="
                      font-family: 楷体_GB2312;
                      line-height: 150%;
                      font-size: 19px;
                    "
                    >&nbsp;</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >法人或授权代表（签字）：</span
                  ><span
                    style="font-size: 19px"
                    class="partA_sign"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_sign }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 19px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px">联系电话：</span>
                  <span
                    class="partA_phone"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_phone }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >日期：</span
                  ><span
                    style="font-size: 19px"
                    class="partA_date"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_date }}</span
                  >
                </p>
              </td>
              <td
                width="285"
                style="
                  border-width: 0;
                  border-left: 0;
                  padding: 2px 7px;
                  border-style: solid;
                "
              >
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >乙方单位（盖章）：</span
                  ><span
                    style="font-size: 19px"
                    class="partB_gongzhang"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_gongzhang }}</span
                  >
                </p>
                <p style="line-height: 150%">
                  <span
                    style="
                      font-family: 楷体_GB2312;
                      line-height: 150%;
                      font-size: 19px;
                    "
                    >&nbsp;</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >法人或委授权代表（签字）：</span
                  ><span
                    style="font-size: 19px"
                    class="partB_sign"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_sign }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 19px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px">联系电话：</span>
                  <span
                    class="partB_phone"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_phone }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >日期：</span
                  ><span
                    style="font-size: 19px"
                    class="partB_date"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_date }}</span
                  >
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <p>
          <br />
        </p>
      </div>
      <div class="printWrap" v-show="false">
        <div
          v-html="concretMixContent"
          class="mainHtml"
          id="printconcretMixContent"
        ></div>
      </div>
    </div>
    <setWatermarkDialog
      ref="setWatermarking"
      @setWaterMarkFun="setWaterMarkFun"
    ></setWatermarkDialog>
  </div>
</template>

<script>
import {
  getServiceContractDetailService, //获取合同填充内容
} from "@/services/allContractServices";
import printJS from "print-js";
import { mixins } from "@/page/contract/template/mixin.js";
import setWatermarkDialog from "../../commonCell/setWatermarkDialog.vue";
import { addPageNum, getTableData } from "../common.js";
import { addPageNumCustom } from "../common.js";

export default {
  name: "concretMixContract",
  mixins: [mixins],
  components: {
    setWatermarkDialog,
  },
  data() {
    return {
      concretMixContent: "", //富文本编辑器内容
      watermark: [""],
      saveflag: false,
      detailForm: { ...this.dialogForm },
      tableKey: Math.random(),
      tableKey1: Math.random(),
      concretMixtableList: [
        {
          id: 1,
          column0: "1",
          column1: "混凝土拌合机",
          column2: "",
          column3: "台",
          column4: "",
          column5: "",
          column6: "",
        },
        {
          id: 2,
          column0: "2",
          column1: "混凝土罐车",
          column2: "/",
          column3: "台",
          column4: "",
          column5: "",
          column6: "",
        },
      ], //中间表格数据
      pricetableList: [
        {
          id: 1,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
          column8: "",
        },
        {
          id: 2,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
          column8: "",
        },
        {
          id: 3,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
          column8: "",
        },
        {
          id: 1000,
          column0: "",
          column1: "合计",
          column2: "小写（含税）：",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
          column8: "",
        },
        {
          id: 1001,
          column0: "",
          column1: "大写（含税）：",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
          column8: "",
        },
        {
          id: 1002,
          column0: "",
          column1: "不含税总价：       税金：",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
          column8: "",
        },
      ], //第二个表格数据
      inputPages: "",
      inputHeight: 1010,
      inputPosx: 37,
    };
  },
  methods: {
    addItem() {
      let len = this.concretMixtableList.length - 1;
      let id = (this.concretMixtableList[len]?.id ?? 0) + 1;
      let item = {
        id: id,
        column0: "",
        column1: "",
        column2: "",
        column3: "",
        column4: "",
        column5: "",
        column6: "",
      };
      this.concretMixtableList.push(item);
    },
    delItem() {
      if (this.concretMixtableList.length > 0)
        this.concretMixtableList.splice(-1, 1);
    },

    addItem1() {
      let len = this.pricetableList.length - 4;
      let id = (this.pricetableList[len]?.id ?? 0) + 1;
      let item = {
        id: id,
        column0: "",
        column1: "",
        column2: "",
        column3: "",
        column4: "",
        column5: "",
        column6: "",
        column7: "",
        column8: "",
      };
      this.pricetableList.splice(len + 1, 0, item);
    },
    delItem1() {
      if (this.pricetableList.length > 0) this.pricetableList.splice(-4, 1);
    },
    /**
     * 初始化全部订单表格数据,配置表格列等数据
     *
     **/
    initOrderDetailTable() {
      this.getTableData();
    },
    //获取一条劳务合同信息
    getsubServiceContractDetail(id) {
      if (!id) return;
      let param = {};
      param.id = id;
      getServiceContractDetailService(param)
        .then((res) => {
          if (res.code == 10000000) {
            let data = {};
            if (res.data.subContractPrintVO) {
              data = res.data.subContractPrintVO;
              this.watermark = res.data.subContractPrintVO.watermark || [""];
              if (data.content) {
                this.saveflag = true;
                this.detailForm = JSON.parse(data.content);
                if (this.detailForm.concretMixtableList)
                  this.concretMixtableList = JSON.parse(
                    this.detailForm.concretMixtableList
                  );
                this.concretMixtableList.forEach((item, index) => {
                  item.id = index + 1;
                  return item;
                });
                if (this.detailForm.pricetableList)
                  this.pricetableList = JSON.parse(
                    this.detailForm.pricetableList
                  );
                this.pricetableList.forEach((item, index) => {
                  if (index == this.pricetableList.length - 3) {
                    item.id = 1000;
                  } else if (index == this.pricetableList.length - 2) {
                    item.id = 1001;
                  } else if (index == this.pricetableList.length - 1) {
                    item.id = 1002;
                  } else {
                    item.id = index + 1;
                  }
                  return item;
                });
              } else {
                this.detailForm = { ...this.dialogForm };
                this.pricetableList = [
                  {
                    id: 1,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                    column8: "",
                  },
                  {
                    id: 2,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                    column8: "",
                  },
                  {
                    id: 3,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                    column8: "",
                  },
                  {
                    id: 1000,
                    column0: "",
                    column1: "合计",
                    column2: "小写（含税）：",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                    column8: "",
                  },
                  {
                    id: 1001,
                    column0: "",
                    column1: "大写（含税）：",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                    column8: "",
                  },
                  {
                    id: 1002,
                    column0: "",
                    column1: "不含税总价：       税金：",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                    column8: "",
                  },
                ];
                this.concretMixtableList = [
                  {
                    id: 1,
                    column0: "1",
                    column1: "混凝土拌合机",
                    column2: "",
                    column3: "台",
                    column4: "",
                    column5: "",
                    column6: "",
                  },
                  {
                    id: 2,
                    column0: "2",
                    column1: "混凝土罐车",
                    column2: "/",
                    column3: "台",
                    column4: "",
                    column5: "",
                    column6: "",
                  },
                ];
              }
            }
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
          this.loading=false;
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
          this.loading=false;
        });
    },
    /**
     * 关闭当前tab页面
     */
    closePage() {
      this.bus.$emit("tabClose", "order-detail");
    },
    ClosePrintOrder() {
      this.orderbillNo = [];
      this.orderDetailList = [];
    },
    saveContractA() {
      if (this.detailForm.approveStatus == 2) {
        this.$alert("合同为待审核无法修改", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      // this.getValues();
      const table = this.$refs.onlyPriceTable;
      this.concretMixtableList = getTableData(
        table,
        this.concretMixtableList,
        7
      );
      this.detailForm.concretMixtableList = JSON.stringify(
        this.concretMixtableList
      );
      this.tableKey = Math.random();
      //第二个表格
      const table1 = this.$refs.pricetableListref;
      this.pricetableList = getTableData(table1, this.pricetableList, 9);
      this.detailForm.pricetableList = JSON.stringify(this.pricetableList);
      this.tableKey1 = Math.random();
      this.saveCommon('concretMixContract');
    },
    getValues() {
      // let Id = document.getElementById("HTMLconcretMixContent");
      let Id = document.getElementsByClassName(this.printClass)[0];
      this.detailForm.serialNumber =
        Id.getElementsByClassName("serialNumber")[0].innerText.trim();
      this.detailForm.partyA =
        Id.getElementsByClassName("partyA")[0].innerText.trim();
      this.detailForm.partyB =
        Id.getElementsByClassName("partyB")[0].innerText.trim();
      this.detailForm.project =
        Id.getElementsByClassName("project")[0].innerText.trim();
        Id.getElementsByClassName("project")[0].innerHTML = this.detailForm.project;
      this.detailForm.projectName =
        Id.getElementsByClassName("projectName")[0].innerText.trim();
      this.detailForm.signPlace =
        Id.getElementsByClassName("signPlace")[0].innerText.trim();
      Id.getElementsByClassName("signPlace")[0].innerHTML =
        this.detailForm.signPlace;
      this.detailForm.signDate =
        Id.getElementsByClassName("signDate")[0].innerText.trim();
      Id.getElementsByClassName("signDate")[0].innerHTML =
        this.detailForm.signDate;
      this.detailForm.bhjSignPlace =
        Id.getElementsByClassName("bhjSignPlace")[0].innerText.trim();
      this.detailForm.bhjgdj =
        Id.getElementsByClassName("bhjgdj")[0].innerText.trim();
      this.detailForm.bhjgretio =
        Id.getElementsByClassName("bhjgretio")[0].innerText.trim();
      this.detailForm.hntysdj =
        Id.getElementsByClassName("hntysdj")[0].innerText.trim();
      this.detailForm.hntysretio =
        Id.getElementsByClassName("hntysretio")[0].innerText.trim();
      this.detailForm.addPrice =
        Id.getElementsByClassName("addPrice")[0].innerText;
      this.detailForm.slfw = Id.getElementsByClassName("slfw")[0].innerText;

      this.detailForm.startDate =
        Id.getElementsByClassName("startDate")[0].innerText.trim();
      Id.getElementsByClassName("startDate")[0].innerHTML =
        this.detailForm.startDate;
      this.detailForm.endDate =
        Id.getElementsByClassName("endDate")[0].innerText.trim();
      Id.getElementsByClassName("endDate")[0].innerHTML =
        this.detailForm.endDate;

      Id.getElementsByClassName("bhjSignPlace")[0].innerHTML =
        this.detailForm.bhjSignPlace;
      Id.getElementsByClassName("bhjgdj")[0].innerHTML = this.detailForm.bhjgdj;
      Id.getElementsByClassName("bhjgretio")[0].innerHTML =
        this.detailForm.bhjgretio;
      Id.getElementsByClassName("hntysdj")[0].innerHTML =
        this.detailForm.hntysdj;
      Id.getElementsByClassName("hntysretio")[0].innerHTML =
        this.detailForm.hntysretio;
      Id.getElementsByClassName("addPrice")[0].innerHTML =
        this.detailForm.addPrice;

      Id.getElementsByClassName("slfw")[0].innerHTML = this.detailForm.slfw;

      this.detailForm.name =
        Id.getElementsByClassName("name")[0].innerText.trim();
      this.detailForm.phone =
        Id.getElementsByClassName("phone")[0].innerText.trim();
      this.detailForm.idCard =
        Id.getElementsByClassName("idCard")[0].innerText.trim();
      this.detailForm.fksm1 =
        Id.getElementsByClassName("fksm1")[0].innerText.trim();
      // this.detailForm.fksm2 =
      //   Id.getElementsByClassName("fksm2")[0].innerText.trim();
      // this.detailForm.fksm3 =
      //   Id.getElementsByClassName("fksm3")[0].innerText.trim();
      this.detailForm.shuoming =
        Id.getElementsByClassName("shuoming")[0].innerText.trim();
      this.detailForm.deretio =
        Id.getElementsByClassName("deretio")[0].innerText.trim();
      this.detailForm.kgrqYear =
        Id.getElementsByClassName("kgrqYear")[0].innerText.trim();
      this.detailForm.kgrqMonth =
        Id.getElementsByClassName("kgrqMonth")[0].innerText.trim();
      this.detailForm.kgrqDay =
        Id.getElementsByClassName("kgrqDay")[0].innerText.trim();
      this.detailForm.carNum =
        Id.getElementsByClassName("carNum")[0].innerText.trim();

      this.detailForm.gljlAname =
        Id.getElementsByClassName("gljlAname")[0].innerText.trim();
      this.detailForm.gljlAphone =
        Id.getElementsByClassName("gljlAphone")[0].innerText.trim();
      this.detailForm.gljlBname =
        Id.getElementsByClassName("gljlBname")[0].innerText.trim();
      this.detailForm.gljlBphone =
        Id.getElementsByClassName("gljlBphone")[0].innerText.trim();

      this.detailForm.contractTotal =
        Id.getElementsByClassName("contractTotal")[0].innerText.trim();
      this.detailForm.contractAnum =
        Id.getElementsByClassName("contractAnum")[0].innerText.trim();
      this.detailForm.contractBnum =
        Id.getElementsByClassName("contractBnum")[0].innerText.trim();

      Id.getElementsByClassName("name")[0].innerHTML = this.detailForm.name; //拌合机地点
      Id.getElementsByClassName("phone")[0].innerHTML = this.detailForm.phone;
      Id.getElementsByClassName("idCard")[0].innerHTML = this.detailForm.idCard;

      Id.getElementsByClassName("fksm1")[0].innerHTML = this.detailForm.fksm1;
      // Id.getElementsByClassName("fksm2")[0].innerHTML = this.detailForm.fksm2;
      // Id.getElementsByClassName("fksm3")[0].innerHTML = this.detailForm.fksm3;
      Id.getElementsByClassName("shuoming")[0].innerHTML =
        this.detailForm.shuoming;
      Id.getElementsByClassName("deretio")[0].innerHTML =
        this.detailForm.deretio;
      Id.getElementsByClassName("kgrqYear")[0].innerHTML =
        this.detailForm.kgrqYear; //拌合机地点
      Id.getElementsByClassName("kgrqMonth")[0].innerHTML =
        this.detailForm.kgrqMonth;
      Id.getElementsByClassName("kgrqDay")[0].innerHTML =
        this.detailForm.kgrqDay;

      Id.getElementsByClassName("gljlAname")[0].innerHTML =
        this.detailForm.gljlAname;
      Id.getElementsByClassName("gljlAphone")[0].innerHTML =
        this.detailForm.gljlAphone;
      Id.getElementsByClassName("gljlBname")[0].innerHTML =
        this.detailForm.gljlBname;
      Id.getElementsByClassName("gljlBphone")[0].innerHTML =
        this.detailForm.gljlBphone;
      Id.getElementsByClassName("contractTotal")[0].innerText =
        this.detailForm.contractTotal;
      Id.getElementsByClassName("contractAnum")[0].innerText =
        this.detailForm.contractAnum;
      Id.getElementsByClassName("contractBnum")[0].innerText =
        this.detailForm.contractBnum;
      Id.getElementsByClassName("carNum")[0].innerText = this.detailForm.carNum;

      this.detailForm.partA_gongzhang =
        Id.getElementsByClassName("partA_gongzhang")[0].innerText;
      Id.getElementsByClassName("partA_gongzhang")[0].innerHTML =
        this.detailForm.partA_gongzhang;
      this.detailForm.partA_sign =
        Id.getElementsByClassName("partA_sign")[0].innerText;
      Id.getElementsByClassName("partA_sign")[0].innerHTML =
        this.detailForm.partA_sign;
      this.detailForm.partA_phone =
        Id.getElementsByClassName("partA_phone")[0].innerText;
      Id.getElementsByClassName("partA_phone")[0].innerHTML =
        this.detailForm.partA_phone;
      this.detailForm.partA_date =
        Id.getElementsByClassName("partA_date")[0].innerText;
      Id.getElementsByClassName("partA_date")[0].innerHTML =
        this.detailForm.partA_date;

      this.detailForm.partB_gongzhang =
        Id.getElementsByClassName("partB_gongzhang")[0].innerText;
      Id.getElementsByClassName("partB_gongzhang")[0].innerHTML =
        this.detailForm.partB_gongzhang;
      this.detailForm.partB_sign =
        Id.getElementsByClassName("partB_sign")[0].innerText;
      Id.getElementsByClassName("partB_sign")[0].innerHTML =
        this.detailForm.partB_sign;
      this.detailForm.partB_phone =
        Id.getElementsByClassName("partB_phone")[0].innerText;
      Id.getElementsByClassName("partB_phone")[0].innerHTML =
        this.detailForm.partB_phone;
      this.detailForm.partB_date =
        Id.getElementsByClassName("partB_date")[0].innerText;
      Id.getElementsByClassName("partB_date")[0].innerHTML =
        this.detailForm.partB_date;
    },
    //打印当前合同
    PrintContractD() {
      if (this.dialogForm.approveStatus != 3) {
        this.$alert("合同尚未通过审核，无法打印", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      // let Id = document.getElementById("HTMLconcretMixContent");
      let Id = document.getElementsByClassName(this.printClass)[0];
      let elementsToRemove = Id.querySelectorAll(".page-num");
      elementsToRemove.forEach(function (element) {
        element.parentNode.removeChild(element);
      });
      //addPageNum(Id);
      addPageNumCustom(Id, 0, "default", this.inputPages, this.inputHeight, this.inputPosx);
      this.$set(
        this,
        "concretMixContent",
        this.$refs.HTMLconcretMixContent.innerHTML
      );
      this.$nextTick(() => {
        printJS({
          printable: "printconcretMixContent",
          type: "html",
          targetStyles: ["*"],
          ignoreElements: ["no-print", "bc", "gb"],
          scanStyles: false,
          style: `@page { size: auto; margin:10mm } p{line-height: 31px} .HTMLconcretMixContract1 {background: url("data:image/svg+xml,%3Csvg width='200' height='200' xmlns='http://www.w3.org/2000/svg'%3E%3Ctext x='50%25' y='50%25' font-size='14' fill-opacity='0.3' text-anchor='middle' dominant-baseline='middle' transform='rotate(-35, 100 100)'%3E${this.watermark.join(
            ";"
          )}%3C/text%3E%3C/svg%3E");
}`,
        });
      });
    },
    //设置水印
    setWatermark() {
      this.$refs.setWatermarking.showwaterMarkDialog(
        this.subServiceContractId,
        this.watermark
      );
    },
    setWaterMarkFun(val) {
      this.watermark = val;
      let param = {
        warterMark: this.watermark,
        version: "1.0",
        flag: 2,
      };
      this.$emit("savePrintInfo", param);
    },
  },
};
</script>

<style>
#HTMLconcretMixContent {
  /* position: relative; */
  width: 20cm;
  padding: 0 10px;
  margin-top: 58px;
  box-shadow: 0px 4px 12px 2px #bbb;
}
p {
  line-height: 31px;
}
.buttons {
  width: 22cm;
  height: 56px;
  position: fixed;
  top: 90px;
  background: white;
  z-index: 9;
}

.printWrap {
  width: 21cm;
  margin: 30px auto;
  padding: 5mm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

.mainHtml {
  width: 21cm;
}
</style>
